import { render, staticRenderFns } from "./music-btn.vue?vue&type=template&id=6288c505&scoped=true&"
import script from "./music-btn.vue?vue&type=script&lang=js&"
export * from "./music-btn.vue?vue&type=script&lang=js&"
import style0 from "./music-btn.vue?vue&type=style&index=0&id=6288c505&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6288c505",
  null
  
)

export default component.exports